import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CartService, ConfigurationService, OrderService, PathsService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Participant } from 'models/participant';
import { Observable, BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { GenericModalService } from '../../../generic-modal/services/generic-modal.service';

@Component({
    selector: 'da-participants-list',
    templateUrl: './participants-list.component.html',
    styleUrls: ['./participants-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ParticipantsListComponent implements OnInit {
    @Input() participants: Array<Participant> = [];
    @Input() isBookingSummary: Array<Participant> = [];
    private _modalId: string;
    @ViewChild('overlay', { static: true }) private _overlay;

    private _$showErrorMessageBackEnd: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public get showErrorMessageBackEnd$(): Observable<{}> {
        return this._$showErrorMessageBackEnd.asObservable();
    }

    constructor(
        private orderService: OrderService,
        private _genericModalService: GenericModalService,
        private router: Router,
        private _localizeRouterService: LocalizeRouterService,
        private _cartService: CartService
    ) {}

    ngOnInit() {
        this.orderService.order$.pipe(take(1)).subscribe((order) => {
            this.participants = order.participants;
        });
    }

    removeParticipant(i) {
        this.orderService.order$.pipe(take(1)).subscribe((order) => {
            this.participants.forEach((item, index) => {
                if (item.person.id === this.participants[i].person.id) {
                    if (this.participants.length > 1) {
                        this.participants.splice(index, 1);
                    } else {
                        if (this.isBookingSummary) {
                            this.showWarning();
                        } else {
                            this.participants.splice(index, 1);
                        }
                    }
                    order.participants = this.participants;
                    this.orderService.updateOrder(order);
                }

                this.orderService.updateOrder(order);
            });
        });
    }

    public showWarning(): void {
        this._overlayHandler();
    }

    private async _overlayHandler(): Promise<void> {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, this._overlay, true);
    }

    public goToEditParticipants() {
        this._cartService.updateActiveAtep(2);
        this._genericModalService.close(this._modalId);
    }

    public cancleOrder() {
        this.participants = [];
        this.orderService.cancleOrder();
        this.closeModal();

        let translatedPath: any = this._localizeRouterService.translateRoute('/' + 'courses');
        this.router.navigate([translatedPath]);
    }

    public closeModal() {
        this._genericModalService.close(this._modalId);
    }
}
